import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Futsal = () => {
  return (
    <SportsLayoutComp name={'Futsal'}/>
  )
}

export default Futsal